import { api } from "@/api/client";

export type HelpChatTurn = {
  role: "user" | "assistant";
  content: string;
};

export async function postHelpChat(body: {
  locale: "pt-BR" | "en";
  messages: HelpChatTurn[];
}): Promise<{ reply: string }> {
  const { data } = await api.post<{ reply: string }>("/v1/help/chat", body);
  return data;
}
